module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "calibre_15",
    attrs: {
      "id": "calibre_pb_20"
    }
  }, [_c('span', {
    staticClass: "calibre10"
  }, [_vm._v("PHYSICS AND METAPHYSICS")])]), _vm._v(" "), _c('h2', {
    staticClass: "calibre_22",
    attrs: {
      "id": "filepos64620"
    }
  }, [_c('span', {
    staticClass: "calibre10"
  }, [_c('span', {
    staticClass: "italic1"
  }, [_vm._v("3 "), _c('img', {
    staticClass: "calibre11",
    attrs: {
      "alt": "image",
      "src": "images/00004.jpg"
    }
  }), _vm._v(" Man Is a River")])])]), _c('div', {
    staticClass: "calibre_14"
  }), _vm._v(" "), _c('p', {
    staticClass: "calibre_18"
  }, [_c('span', {
    staticClass: "calibre5"
  }, [_vm._v("A river has a name, a character, a personality; it is liked or disliked as an entity. This is due to a variety of factors: its rapidity or sluggishness, its breadth, depth, length, its form and course, its smoothness, number of islands, and the vegetation and topographical character of its immediate environment. But it flows; from whatever angle you may look, it is never the same for two consecutive seconds. It is just passing water, each ripple, each drop, resembling its predecessor and its successor but never the same ripple or drop.")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre_19"
  }, [_c('span', {
    staticClass: "calibre5"
  }, [_vm._v("There is no river. There is no man.")])]), _vm._v(" "), _c('div', {
    staticClass: "mbp_pagebreak",
    attrs: {
      "id": "calibre_pb_21"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f2c9412c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/index_split_013.vue
// module id = 99
// module chunks = 0